import React from 'react';
import resultImage from 'images/result_test.png';

const ExamFinished = (props) => {
    let { examResult, exam_id } = props;

    return(
        <div className="m-portlet m-portlet--primary m-portlet--head-solid-bg">
            <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <div className="m-portlet__head-text mr-5">
                            Terminó el examen
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-portlet__body m-form__group form-group m-radio-list mb-0 test-finished">
                {exam_id === 74 &&
                    <div className="row justify-content-center">
                        <div className="col-9 title" style={{color: '#1aaf53'}}>
                            <b>INGLÉS 2.0 - A1 INSTITUCIONAL DE SUFICIENCIA - A1</b>
                        </div>
                    </div>
                }
                <div className="row justify-content-center">
                    <div className="col-9 title">
                        Gracias por presentar tu examen en el Centro de Idiomas de la Universidad Autónoma de Chihuahua
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-6">
                        <img src={resultImage} />
                    </div>
                </div>
                <div className="row justify-content-center mt-5 result">
                    <div className="col-6">
                      <i>El resultado de tu examen es:</i>
                    </div>
                </div>
                <div className="row justify-content-center mt-3 result">
                    <div className="col-6">
                      <b>{examResult}</b>
                    </div>
                </div>
                <div className="row justify-content-center mt-3 result">
                    <div className="col-6">
                        { exam_id !== 74 && exam_id !== 36 &&
                            <p>
                                <b>Importante:</b> En el transcurso del día recibirás un correo electrónico a tu cuenta
                                institucional con la fecha y hora asignados para la entrevista
                            </p>
                        }
                        { exam_id === 36 &&
                            <p>
                                <b>Fase 2 </b> - No olvides ingresar puntualmente a tu entrevista el día y hora
                                indicados en el correo que recibiste en tu cuenta institucional de la UACH
                            </p>
                        }
                        { exam_id === 74 &&
                            <p>
                                <b>Ya puedes inscribirte en la UDA de Inglés A2.1</b>
                            </p>
                        }
                    </div>
                </div>
                <div className="row justify-content-center mt-3 result">
                    <div className="col-6">
                        <a className="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                           rel="nofollow" data-method="delete" href="/sign_out">Terminar</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExamFinished;
